import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Form, Table } from 'react-bootstrap';
import dayjs from 'dayjs';
import { getSalary } from '@/api/index';
import { Ic } from '@/components/basic/index';
import style from '@/pages/report/Report.scss';

const TuitionFees = ({ studentId = null }) => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [salaries, setSalaries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);

  const years = Array.from({ length: 6 }, (_, i) => currentYear - i);

  const toggleRow = (index) => {
    setExpandedRows((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]));
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('ja-JP').format(num);
  };

  useEffect(async () => {
    setLoading(true);
    try {
      const data = await getSalary(year);
      setSalaries(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [year]);

  const calculateTotal = (key) => {
    return salaries.reduce((acc, curr) => acc + (curr[key] || 0), 0);
  };

  return (
    <Container fluid>
      <div style={{ marginTop: '1rem' }}>
        <Form.Group className="mb-3" style={{ maxWidth: '200px' }}>
          <Form.Label>年選択</Form.Label>
          <Form.Select value={year} onChange={(e) => setYear(e.target.value)}>
            {years.map((y) => (
              <option key={y} value={y}>
                {y}年
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        {loading ? (
          <div>読み込み中...</div>
        ) : (
          <Table responsive bordered hover className={style.scoreTable}>
            <thead>
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <th>年月</th>
                <th>指導料</th>
                <th>交通費</th>
                <th>合計金額</th>
              </tr>
            </thead>
            <tbody>
              {salaries && salaries.length > 0 ? (
                <>
                  {salaries.map((s, index) => (
                    <React.Fragment key={index}>
                      <tr style={{ cursor: 'pointer' }} onClick={() => toggleRow(index)}>
                        <td>
                          {s.month}月
                          {s.details && s.details.length > 0 ? (
                            <span className="ms-2">
                              <Ic iName={expandedRows.includes(index) ? 'faChevronDown' : 'faChevronRight'} />
                            </span>
                          ) : null}
                        </td>
                        <td className="text-end">{formatNumber(s.salary)}</td>
                        <td className="text-end">{formatNumber(s.transportationFee)}</td>
                        <td className="text-end">{formatNumber(s.totalAmount)}</td>
                      </tr>
                      {expandedRows.includes(index) &&
                        s.details &&
                        s.details.map((detail, dIndex) => {
                          const salary = detail.salary ?? detail.fee ?? 0;
                          const transportationFee = detail.transportationFee ?? detail.travelCost ?? 0;
                          const totalAmount = detail.totalAmount ?? salary + transportationFee;
                          const isApproved = !!detail.approveAt;
                          const rowStyle = isApproved ? { backgroundColor: '#fdfdfd', fontSize: '0.9rem' } : { backgroundColor: '#e9ecef', fontSize: '0.9rem' };
                          const formatDate = (date) => (date ? dayjs(date).format('MM/DD') : '');
                          return (
                            <tr key={`${index}-${dIndex}`} style={rowStyle}>
                              <td style={{ paddingLeft: '2rem' }}>
                                指導:{formatDate(detail.date)} 承認:{detail.approveAt ? formatDate(detail.approveAt) : '(未承認)'} {detail.studentName}
                              </td>
                              <td className="text-end">{formatNumber(salary)}</td>
                              <td className="text-end">{formatNumber(transportationFee)}</td>
                              <td className="text-end">{formatNumber(totalAmount)}</td>
                            </tr>
                          );
                        })}
                    </React.Fragment>
                  ))}
                  <tr style={{ backgroundColor: '#eee', fontWeight: 'bold' }}>
                    <td className="text-center">年間合計</td>
                    <td className="text-end">{formatNumber(calculateTotal('salary'))}</td>
                    <td className="text-end">{formatNumber(calculateTotal('transportationFee'))}</td>
                    <td className="text-end">{formatNumber(calculateTotal('totalAmount'))}</td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    データがありません
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </div>
    </Container>
  );
};

TuitionFees.propTypes = {
  studentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TuitionFees;
